import { affiliateDisclosureFor } from "../lib/affiliateDisclosure";

export default function AffiliateLinkLabel({
  record,
  destinationUrl,
  testId = "affiliate-link-label",
  className = "",
}) {
  const disclosure = affiliateDisclosureFor(record, destinationUrl);
  if (!disclosure.isAffiliateLink) return null;
  return (
    <span
      data-testid={testId}
      title={disclosure.disclosure}
      className={`inline-flex items-center rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-amber-800 ${className}`}
    >
      {disclosure.label}
    </span>
  );
}
